import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Profile from './pages/Profile';
import DocumentList from './pages/DocumentList';

// Admin pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminUsers from './pages/admin/Users';
import AdminAccounts from './pages/admin/Accounts';
import AdminSales from './pages/admin/Sales';
import AdminEmails from './pages/admin/Emails';
import AdminLogs from './pages/admin/Logs';
import CostManagement from './pages/admin/CostManagement';
import CostSettlement from './pages/admin/CostSettlement';

// Developer pages
import DeveloperDashboard from './pages/developer/Dashboard';
import DeveloperAccounts from './pages/developer/Accounts';
import DeveloperSales from './pages/developer/Sales';
import DeveloperEmails from './pages/developer/Emails';

// Sales pages
import SalesDashboard from './pages/sales/Dashboard';
import SalesRecords from './pages/sales/Records';
import SalesEmails from './pages/sales/Emails';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  const getDefaultRoute = () => {
    if (!user) return '/login';
    switch (user.role) {
      case 'admin':
        return '/admin/dashboard';
      case 'developer':
        return '/developer/dashboard';
      case 'sales':
        return '/sales/dashboard';
      default:
        return '/login';
    }
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Profile - all authenticated users */}
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Layout><Profile /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <PrivateRoute>
            <Layout><DocumentList /></Layout>
          </PrivateRoute>
        }
      />

      {/* Admin routes */}
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><AdminDashboard /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><AdminUsers /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/accounts"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><AdminAccounts /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/sales"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><AdminSales /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/emails"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><AdminEmails /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/logs"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><AdminLogs /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/cost-management"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><CostManagement /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/cost-settlement"
        element={
          <PrivateRoute roles={['admin']}>
            <Layout><CostSettlement /></Layout>
          </PrivateRoute>
        }
      />

      {/* Developer routes */}
      <Route
        path="/developer/dashboard"
        element={
          <PrivateRoute roles={['developer']}>
            <Layout><DeveloperDashboard /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/developer/accounts"
        element={
          <PrivateRoute roles={['developer']}>
            <Layout><DeveloperAccounts /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/developer/sales"
        element={
          <PrivateRoute roles={['developer']}>
            <Layout><DeveloperSales /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/developer/emails"
        element={
          <PrivateRoute roles={['developer']}>
            <Layout><DeveloperEmails /></Layout>
          </PrivateRoute>
        }
      />

      {/* Sales routes */}
      <Route
        path="/sales/dashboard"
        element={
          <PrivateRoute roles={['sales']}>
            <Layout><SalesDashboard /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/sales/records"
        element={
          <PrivateRoute roles={['sales']}>
            <Layout><SalesRecords /></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/sales/emails"
        element={
          <PrivateRoute roles={['sales']}>
            <Layout><SalesEmails /></Layout>
          </PrivateRoute>
        }
      />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />
      <Route path="*" element={<Navigate to={getDefaultRoute()} replace />} />
    </Routes>
  );
}

export default App;
